<template>
  <div id="home">
    <Header @showModal="openModal" />
    <div class="pushable" id="home-pushable">
      <Sidebar />
      <div :id="pusherId" :class="pusherClass">
        <router-view id="content-router-view" @openCreateContentModal="openModal" />
      </div>
    </div>
    <CreateContentModal ref="ccmodal" />
  </div>
</template>

<script>
import Header from '@/components/shared/navs/Header';
import Sidebar from '@/components/shared/navs/Sidebar';
import CreateContentModal from '@/components/content/create/CreateContentModal.vue';

export default {
  name: 'home',
  components: {
    Header,
    Sidebar,
    CreateContentModal,
  },
  computed: {
    fixedLayout() {
      return this.$route.meta.layout === 'fixed';
    },
    pusherClass() {
      return this.fixedLayout ? 'ui basic fluid segment' : '';
    },
    pusherId() {
      return this.fixedLayout ? 'fixed-content' : 'scroll-content';
    },
  },
  methods: {
    openModal() {
      this.$refs.ccmodal.showModal();
    },
  },
  mounted() {
    this.$store.dispatch('getAuthentications');
  },
};
</script>

<style lang="less" scoped>
#home {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  max-height: 100%;

  .pushable {
    flex: 0 1 auto;
    overflow: hidden;
    #fixed-content {
      margin: 2em;
      margin-left: 8em;

      #content-router-view {
        display: block;
        overflow: hidden;
        height: calc(100vh - 120px);
      }
    }
    #scroll-content {
      margin-left: 6em;

      #content-router-view {
        height: 100vh;
        overflow: auto;
        padding: 2em 2em 6em 2em !important;
      }
    }
  }
}
</style>
